<template>
  <ag-modal-container
    :title="$t('ontime.title.updateVersion')"
    width="900px"
    @close="back"
  >
    <version-form
      v-if="value"
      v-model="value"
      :disabled-default-options="isDisabledDefaultOptions"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid || !value"
        color="primary"
        class="ml-5"
        @click="update"
        v-text="$t('general.update')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import VersionForm from '../components/VersionForm'

export default {
  name: 'VersionUpdateContainer',
  components: {
    AgModalContainer,
    VersionForm,
  },
  props: {
    versionId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: null,
    isDisabledDefaultOptions: false,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.ontime.version.get(this.versionId)
        // Disable changes to default options if one is set
        if (this.value.defaultVersion) {
          this.isDisabledDefaultOptions = true
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async update () {
      this.loading = true
      try {
        await Repositories.ontime.version.patch(this.value)
        this.showSuccessNotification(this.$t('ontime.fields.success.versionUpdated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
